'use client';
import AppLayout from '@/components/AppLayout';
import CameraTimelineScreen from './components/CameraTimelineScreen';

export default function CameraTimelinePage() {
  return (
    <AppLayout>
      <CameraTimelineScreen />
    </AppLayout>
  );
}
